<app-dialog
  [title]="!data?.hideQty ? 'Add SKU to shipment' : 'Add SKU to Model'"
  [actions]="actions"
  [description]="data?.shipmentType"
  (action)="action($event)"
  (close)="action($event)"
>
  <div class="add-sku">
    <div class="custom-mat-radio" *ngIf="this.data['prepBy'] !== undefined && !(this.data.account === 'Walmart' && this.data.status === 'DRAFT')">
      <mat-radio-group aria-label="Select an option" [formControl]="prepByAmazon">
        <mat-radio-button value="false" color="primary" >
          Prep by Seller
        </mat-radio-button>
      
        <mat-radio-button value="true" color="primary" >
          Prep by Amazon
        </mat-radio-button>
      </mat-radio-group>
      <mat-slide-toggle
        [labelPosition]="'before'"
        [(ngModel)]="replace">
        <span style="font-family: var(--font-primary)">Replace current qty</span>
      </mat-slide-toggle>
    </div>
    <div class="add-sku_form mb-3" [formGroup]="skuForm" *ngIf="!importBulk">
      <div class="input-container input-container--flex">
        <div class="d-flex justify-content-between">
          <label for="" class="input-container_label">Search SKUs</label>
          <app-button
            [buttonStyle]="'text underline'"
            [buttonSize]="'action'"
            [buttonColor]="'primary'"
            (click)="importBulk = true"
            >Import Bulk</app-button
          >
        </div>
        <input id="skuAutocomplete"
          type="text"
          class="input-container_input"
          formControlName="skuAutocomplete"
          [matAutocomplete]="auto"
          (paste)="onPaste($event)"
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" (optionSelected)="onChange($event)" >
          <mat-option
            *ngFor="let option of filteredOptions$ | async"
            [value]="option"
            class="mat-option-override">
            <app-item-typeahead
                    [name]="option.title"
                    [sku]="option.sku"
                    [asin]="option.asin"
                    [image]="option.imageUrl"
                    [condition]="option.condition"
            ></app-item-typeahead>
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="input-container input-container--qty" *ngIf="!data?.hideQty">
        <label for="" class="input-container_label">Quantity</label>
        <input
          type="number"
          class="input-container_input"
          [min]="0"
          formControlName="skuQty"
          id="qty"
          (keyup.enter)="verifyAndLoadSku()"
          (keydown.tab)="change($event,'qty')"
        />
        <span class="danger_color2 error-msg mt-2"
          *ngIf="((skuForm.get('skuQty').touched ||
            skuForm.get('skuQty').dirty) && skuForm.get('skuQty').errors)">
        </span>
      </div>

      <div class="add-sku_button">
        <button class="button" (click)="verifyAndLoadSku()" (keydown.tab)="change($event)" [ngClass]="{'focus-only' :focus }" [disabled]="skuForm.invalid">
          Add SKU
        </button>
      </div>
    </div>

    <div *ngIf="importBulk && !validatedSku">
      <form [formGroup]="importBulkForm">
        <div class="input-container w-100">
          <div class="d-flex justify-content-between">
            <label class="input-container_label"
              >Paste Bulk</label
            >
            <app-button
              [buttonStyle]="'text'"
              [buttonSize]="'action'"
              [buttonColor]="'primary'"
              (click)="back()"
            >
              Back</app-button
            >
          </div>
          <textarea
            class="input-container_input"
            rows="10"
            formControlName="skuList"
            placeholder="{{!data.isCaseQty ? data.hideQty ? 'SKU' : 'SKU and QTY - Tab delimited' : 'SKU, Cases and QTY - Tab delimited'}}"
          ></textarea>
        </div>
        <div class="text-center add-sku_importbulk-btn">
          <app-button
            [buttonSize]="'action'"
            [spin]="validatorSpin"
            (click)="validateSkus()"
            [isDisabled]="importBulkForm.invalid"
            >Validate</app-button
          >
        </div>
      </form>
    </div>

    <div class="errors" *ngIf="invalidSkus.length">
      <div class="errors_item">
        <div class="errors_reason">
        <span>The following {{ invalidSkus.length }} SKU(s) are invalid.</span><br />
          {{ invalidSkus.toString() }}
        </div>
      </div>
    </div>

    <div class="errors" [ngClass]="{'invalidFba': invalidSkus.length}" *ngIf="invalidFbatypeSkus.length">
      <div class="errors_item">
        <div class="errors_reason">
          <span>The following {{ invalidFbatypeSkus.length }} SKU(s) are different FBA type.</span><br />
          {{ invalidFbatypeSkus.toString() }}
        </div>
      </div>
    </div>

    <div *ngIf="selectedSKU.length">
      <div class="add-sku_list">
        <div class="add-sku_list-title">Selected SKUs</div>
        <app-shipment-sku
          [box]="true"
          [sku]="sku"
          [skuRemove]="true"
          [hideQty]="data?.hideQty"
          (updateQty)="updateQty(sku)"
          (removeSkuEvent)="removeSku(sku)"
          *ngFor="let sku of selectedSKU"
        ></app-shipment-sku>
      </div>
    </div>
  </div>
</app-dialog>
